import {
  Table,
  Thead,
  Tr,
  Th,
  Box,
  Tbody,
  Td,
  Flex,
  Tooltip,
  useColorModeValue,
  Text,
  Badge,
  Button,
  IconButton,
  VStack,
  Checkbox,
  TableContainer,
  HStack,
  useToast,
} from "@chakra-ui/react";
import { getStatusInfoFromApi } from "@/utils/balanceSolicitationStatusMapper";
import { useConditionalBackground } from "@/contexts/useConditionalBackground";
import { cpfFormatter } from "@/utils/cpfFormatter";
import { useNavigate } from "react-router-dom";
import { ChatIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { FaRegCopy } from "react-icons/fa";
import { handleCopy } from "@/utils/handleCopy";
import { ConsignadoBalanceDetailModal } from "../ConsignadoBalanceDetailModal";
import { ConsignadoBalanceSolicitationAnalysisModal } from "../ConsignadoBalanceSolicitationAnalysisModal";
import {
  ConsigBalanceSolicitation,
  ConsigBalanceSolicitationStatusEnum,
} from "@/models/consignado/balanceSolicitation.model";

interface BalanceSolicitationResultTableProps {
  data: ConsigBalanceSolicitation[];
  selectedIds: string[];
  setSelectedIds: (ids: string[]) => void;
  isConsignado?: boolean;
}
export default function ConsignadoBalanceSolicitationResultTable({
  data,
  selectedIds,
  setSelectedIds,
  isConsignado,
}: BalanceSolicitationResultTableProps) {
  const headerColor = useColorModeValue("white", "white");
  const rowHoverBg = useColorModeValue("teal.50", "teal.900");
  const rowBorderColor = useColorModeValue("gray.200", "gray.600");

  const backgroundStyle = useConditionalBackground();

  const navigate = useNavigate();

  const [selectedItem, setSelectedItem] =
    useState<ConsigBalanceSolicitation | null>(null);
  const [isAnalysisModalOpen, setIsAnalysisModalOpen] = useState(false);
  const [selectedBalanceSolicitationId, setSelectedBalanceSolicitationId] =
    useState<string | null>(null);

  const handleButtonClick = (
    item: ConsigBalanceSolicitation,
    event: React.MouseEvent,
  ) => {
    event.stopPropagation();
    setSelectedBalanceSolicitationId(item.id || null);
    setIsAnalysisModalOpen(true);
  };

  const handleIconButtonClick = (
    event: React.MouseEvent,
    item: ConsigBalanceSolicitation,
  ) => {
    event.stopPropagation();
    setSelectedItem(item);
  };

  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return (
      <VStack spacing={0} align="center">
        <Text fontSize="xs">{date.toLocaleDateString("pt-BR")}</Text>
        <Text fontSize="xs" color="gray.500">
          {date.toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Text>
      </VStack>
    );
  };

  const handleCheckboxChange = (event: React.MouseEvent, id: string) => {
    event.stopPropagation();
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const handleRowClick = (
    event: React.MouseEvent,
    item: ConsigBalanceSolicitation,
  ) => {
    if (
      event.target instanceof HTMLInputElement ||
      event.target instanceof HTMLLabelElement ||
      (event.target instanceof HTMLElement &&
        event.target.contains(
          event.currentTarget.querySelector('input[type="checkbox"]'),
        ))
    ) {
      return;
    }

    setSelectedItem(item);
  };

  const toast = useToast();

  return (
    <>
      <Box
        display="flex"
        flexDirection={{ base: "column", md: "row" }}
        alignItems="center"
        width="100%"
        overflowX={{ base: "auto", md: "visible" }}
      >
        <Box borderRadius="md" boxShadow="md" width={{ base: "", md: "98%" }}>
          <TableContainer borderRadius="md" boxShadow="md" overflow="hidden">
            <Table size="sm">
              <Thead {...backgroundStyle} boxShadow="md">
                <Tr>
                  <Th
                    color={headerColor}
                    textAlign="center"
                    fontSize="0.7rem"
                    py={6}
                  >
                    <Checkbox
                      isChecked={selectedIds?.length === data?.length}
                      onChange={(e) => {
                        e.stopPropagation();
                        if (selectedIds.length === data.length) {
                          setSelectedIds([]);
                        } else {
                          setSelectedIds(data.map((item) => item.id!));
                        }
                      }}
                      size="sm"
                    />
                  </Th>
                  <Th
                    color={headerColor}
                    textAlign="center"
                    fontSize={{
                      base: "0.6rem",
                      md: "0.6rem",
                      lg: "0.6rem",
                    }}
                    py={4}
                  >
                    <HStack justify="center">
                      <Text>Nome do Clinte</Text>
                    </HStack>
                  </Th>
                  <Th
                    color={headerColor}
                    textAlign="center"
                    fontSize={{
                      base: "0.6rem",
                      md: "0.6rem",
                      lg: "0.6rem",
                    }}
                    py={4}
                  >
                    <HStack justify="center">
                      <Text>CPF Cliente</Text>
                    </HStack>
                  </Th>
                  <Th
                    color={headerColor}
                    textAlign="center"
                    fontSize={{
                      base: "0.6rem",
                      md: "0.6rem",
                      lg: "0.6rem",
                    }}
                    py={4}
                  >
                    <HStack mr={4} justify="center">
                      <Text> STATUS </Text>
                    </HStack>
                  </Th>

                  {isConsignado && (
                    <Th
                      color={headerColor}
                      textAlign="center"
                      fontSize={{
                        base: "0.6rem",
                        md: "0.6rem",
                        lg: "0.6rem",
                      }}
                      py={4}
                    >
                      <HStack justify="center">
                        <Text> Termo de Autorização</Text>
                      </HStack>
                    </Th>
                  )}
                  <Th
                    color={headerColor}
                    textAlign="center"
                    fontSize={{
                      base: "0.6rem",
                      md: "0.6rem",
                      lg: "0.6rem",
                    }}
                    py={4}
                  >
                    <HStack justify="center">
                      <Text> Data da consulta</Text>
                    </HStack>
                  </Th>
                  <Th
                    color={headerColor}
                    fontSize={{
                      base: "0.6rem",
                      md: "0.6rem",
                      lg: "0.6rem",
                    }}
                    py={4}
                  >
                    <HStack justify={"center"}>
                      <Text>PROPOSTA</Text>
                    </HStack>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {data?.map((item, index) => {
                  const label = item?.descricao
                    ? item?.descricao
                    : getStatusInfoFromApi(item?.status).tagLabel;

                  return (
                    <Tr
                      key={item.id || index}
                      _hover={{ bg: rowHoverBg }}
                      transition="all 0.3s ease-in-out"
                      borderBottom="1px solid"
                      borderColor={rowBorderColor}
                      cursor="pointer"
                      onClick={(event) => handleRowClick(event, item)}
                    >
                      <Td textAlign="center" fontSize="md" py={3}>
                        <Box onClick={(e) => e.stopPropagation()}>
                          <Checkbox
                            isChecked={selectedIds.includes(item.id!)}
                            onChange={(e) => {
                              e.stopPropagation();
                              handleCheckboxChange(e as any, item.id!);
                            }}
                            size="sm"
                          />
                        </Box>
                      </Td>
                      <Td textAlign="center" fontSize="0.7rem" py={3}>
                        {item?.nome_cliente || "-"}
                      </Td>
                      <Td
                        textAlign="center"
                        fontSize="0.7rem"
                        py={3}
                        whiteSpace="nowrap"
                      >
                        {item?.cpf ? cpfFormatter(item?.cpf) : "-"}
                      </Td>
                      <Td textAlign="center" fontSize="0.7rem" py={3}>
                        <Flex
                          justify="center"
                          align="center"
                          position="relative"
                          width="100%"
                        >
                          <Tooltip
                            label={
                              item?.status !==
                                ConsigBalanceSolicitationStatusEnum.EM_PROCESSAMENTO
                                ? label
                                : ""
                            }
                            hasArrow
                          >
                            <Badge
                              bg={
                                getStatusInfoFromApi(item?.status).colorScheme
                              }
                              px={2}
                              py={2}
                              borderRadius="md"
                              color="white"
                              fontSize={{
                                base: "10px",
                                md: "8px",
                                lg: "8px",
                                xl: "12px",
                              }}
                              width={"90%"}
                              textAlign="center"
                            >
                              {getStatusInfoFromApi(item?.status).label}
                            </Badge>
                          </Tooltip>
                          {item.status !==
                            ConsigBalanceSolicitationStatusEnum.EM_PROCESSAMENTO && (
                              <Box>
                                <Flex>
                                  <Tooltip
                                    fontFamily="Lexend Deca"
                                    label={label}
                                    hasArrow
                                  >
                                    <IconButton
                                      fontFamily="Lexend Deca"
                                      aria-label="Legenda da consulta"
                                      icon={<ChatIcon />}
                                      size={{ base: "0", md: "xs" }}
                                      mr={-4}
                                      variant="ghost"
                                      onClick={(event) =>
                                        handleIconButtonClick(event, item)
                                      }
                                    />
                                  </Tooltip>
                                </Flex>
                              </Box>
                            )}
                        </Flex>
                      </Td>

                      {isConsignado && (
                        <Td textAlign="center" fontSize="0.7rem" py={3}>
                          {item.status ===
                            ConsigBalanceSolicitationStatusEnum.AGUARDANDO_AUTORIZACAO_DO_CLIENTE ? (
                            <Flex
                              alignItems="center"
                              justifyContent={"center"}
                              flexWrap="nowrap"
                            >
                              <Box maxW="100%" minW="0">
                                <Text
                                  color="blue.600"
                                  fontFamily="Lexend Deca"
                                  onClick={() =>
                                    navigate(
                                      item?.termo_consentimento_url ||
                                      "/consignado/autorizar",
                                    )
                                  }
                                  _hover={{
                                    textDecoration: "underline",
                                  }}
                                  // cursor="pointer"
                                  wordBreak="break-all"
                                  overflowWrap="anywhere"
                                  whiteSpace="normal"
                                >
                                  {item.termo_consentimento_url ??
                                    "Erro ao obter link"}
                                </Text>
                              </Box>
                              <IconButton
                                ml={2}
                                aria-label="Copiar Link de acesso ao Termo de Autorização"
                                icon={<FaRegCopy />}
                                onClick={() =>
                                  handleCopy(
                                    item.termo_consentimento_url ??
                                    "Erro ao obter link",
                                    toast,
                                  )
                                }
                                size="sm"
                                variant="ghost"
                                color="gray.500"
                              />
                            </Flex>
                          ) : (
                            "Termo Assinado"
                          )}
                        </Td>
                      )}
                      <Td textAlign="center" fontSize="0.7rem" py={3}>
                        {formatDate(item?.data_criacao.toLocaleString())}
                      </Td>

                      <Td textAlign="center" fontSize="0.7rem" py={3}>
                        <Button
                          colorScheme="primary"
                          onClick={(e) => handleButtonClick(item, e)}
                          size="sm"
                          fontSize="0.7rem"
                          fontFamily="Lexend Deca"
                        >
                          Análise de Crédito
                        </Button>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      <ConsignadoBalanceDetailModal
        isOpen={!!selectedItem}
        onClose={() => setSelectedItem(null)}
        selectedItem={selectedItem}
        formatDate={(date) => new Date(date).toLocaleDateString("pt-BR")}
        isConsignado={true}
      />

        <ConsignadoBalanceSolicitationAnalysisModal
          isOpen={isAnalysisModalOpen}
          onClose={() => {
            setIsAnalysisModalOpen(false);
            setSelectedBalanceSolicitationId(null);
          }}
          balanceSolicitationId={selectedBalanceSolicitationId}
        />
    </>
  );
}
